import styled from "styled-components";
export const LogoWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center;
  z-index: 0;
`;
